/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ExamAttemptReportResponse } from './examAttemptReportResponse';

export type GenericApiResponseExamAttemptReportResponseData = ExamAttemptReportResponse | null;
